$shm_wordstat_task_list $shm_service_task_list
	task_id? \
	task_title_current? \
	focus_queries? null
	tasks_uri \
	List_head $shm_wordstat_task_list_head
		title <= title
		title_uri <= tasks_uri
		search_showed <= search_showed false
		filter? <=> filter? \
		add? <=> add?
		Close null
		Settings null
	tasks /
	add? <=> task_add_new? null
	task_add_new? null
